// Consulting & Strategy Category
import { ShowcaseCategory } from "../showcase-types.ts";
import { ICONS } from "../showcase-icons.ts";

export const consultingStrategyCategory: ShowcaseCategory = {
  id: "consulting-strategy",
  title: {
    en: "Consulting & Strategy",
    lv: "Konsultācijas un Stratēģija",
    it: "Consulenza e Strategia",
  },
  subtitle: {
    en: "Strategic guidance and roadmaps for digital transformation",
    lv: "Stratēģiska vadība un ceļveži digitālajai transformācijai",
    it: "Guida strategica e roadmap per la trasformazione digitale",
  },
  iconGradient: "from-amber-500 to-orange-600",
  iconSvgPath: ICONS.clipboardList,
  projects: [
    {
      id: "enterprise-architecture-analysis",
      title: {
        en: "Enterprise Architecture Analysis",
        lv: "Uzņēmuma Arhitektūras Analīze",
        it: "Analisi dell'Architettura Aziendale",
      },
      industry: {
        en: "Recruitment Services Company",
        lv: "Personāla Atlases Pakalpojumu Uzņēmums",
        it: "Azienda di Servizi di Reclutamento",
      },
      description: {
        en:
          "We delivered a formal Enterprise Architecture assessment focused on Marketing automation. The report outlined a realistic multi-year roadmap for achieving increasing levels of automation and digitalization across the Marketing function. Marketing activity relied on manual processes, disconnected tools, and ad-hoc campaigns—with no unified view of leads and touchpoints. The business wanted a path toward true Marketing automation—but needed to be grounded, phased, and affordable instead of big-bang.",
        lv:
          "Mēs sniedzām formālu Uzņēmuma Arhitektūras novērtējumu, kas koncentrējas uz Mārketinga automatizāciju. Ziņojums izklāstīja reālistisku daudzgadu ceļvedi, lai sasniegtu pieaugošus automatizācijas un digitalizācijas līmeņus visā Mārketinga funkcijā. Mārketinga aktivitāte balstījās uz manuāliem procesiem, atvienotiem rīkiem un ad-hoc kampaņām—bez vienotas skatu uz potenciālajiem klientiem un saskares punktiem. Bizness vēlējās ceļu uz patieso Mārketinga automatizāciju—bet bija nepieciešams būt pamatotam, pakāpeniskam un pieejamam, nevis liela sprādziena.",
        it:
          "Abbiamo consegnato una valutazione formale dell'Architettura Aziendale focalizzata sull'automazione del Marketing. Il rapporto ha delineato una roadmap realistica pluriennale per raggiungere livelli crescenti di automazione e digitalizzazione in tutta la funzione Marketing. L'attività di marketing si basava su processi manuali, strumenti disconnessi e campagne ad-hoc—senza una visione unificata di lead e touchpoint. L'azienda voleva un percorso verso la vera automazione del Marketing—ma doveva essere fondata, graduale e accessibile invece di big-bang.",
      },
      keyOutcomes: [
        {
          text: {
            en:
              "Shared language with leadership, Sales, Marketing, and Exec automation types a common view of where Marketing automation should work",
            lv:
              "Kopīga valoda ar vadību, Pārdošanu, Mārketingu un Izpildvaras automatizācijas veidiem kopīgs skats uz to, kur Mārketinga automatizācijai vajadzētu darboties",
            it:
              "Linguaggio condiviso con leadership, Vendite, Marketing e tipi di automazione Exec una visione comune di dove dovrebbe funzionare l'automazione del Marketing",
          },
        },
        {
          text: {
            en:
              "Mapped current-state: processes, systems, data flows, and pain points",
            lv:
              "Kartēts pašreizējais stāvoklis: procesi, sistēmas, datu plūsmas un sāpju punkti",
            it:
              "Mappato lo stato attuale: processi, sistemi, flussi di dati e punti dolenti",
          },
        },
        {
          text: {
            en:
              "Defined the target-state architecture for Marketing automation step by step",
            lv:
              "Definēta mērķa stāvokļa arhitektūra Mārketinga automatizācijai soli pa solim",
            it:
              "Definita l'architettura dello stato target per l'automazione del Marketing passo dopo passo",
          },
        },
        {
          text: {
            en:
              "Prioritized the roadmap into phases that the business could realistically deliver over the next years",
            lv:
              "Prioritizēts ceļvedis fāzēs, ko bizness varēja reālistiski piegādāt nākamajos gados",
            it:
              "Prioritizzata la roadmap in fasi che l'azienda poteva realisticamente consegnare nei prossimi anni",
          },
        },
      ],
      techBadges: [
        {
          name: "TOGAF methodology",
          colorClass: "bg-amber-100 text-amber-700",
        },
        {
          name: "Enterprise Architecture",
          colorClass: "bg-orange-100 text-orange-700",
        },
        { name: "Microsoft Word", colorClass: "bg-blue-100 text-blue-700" },
      ],
      metric: {
        value: "3-5y",
        label: { en: "Roadmap", lv: "Ceļvedis", it: "Roadmap" },
        sublabel: {
          en: "phased implementation plan",
          lv: "pakāpenisks ieviešanas plāns",
          it: "piano di implementazione graduale",
        },
        colorClass: "text-amber-600",
        bgGradient: "from-amber-50 to-orange-50",
      },
      iconGradient: "from-amber-500 to-orange-600",
      iconSvgPath: ICONS.clipboardList,
    },
  ],
};
